@if (attachment$ | async; as attachment) {
  @if (attachment.isRequested || attachment.isAlreadyRequested) {
    <div class="requested-placeholder">
      <rs-web-icon [icon]="ImmomioIconName.Info" [size]="32"></rs-web-icon>
      <p class="requested-text">
        @if (attachment.isRequested) {
          {{ 'documents.requested_desc_1_l' | translate }}
        }
        @if (attachment.isAlreadyRequested) {
          {{ 'documents.requested_desc_2_l' | translate }}
        }
      </p>
    </div>
  } @else {
    <rs-web-picture [className]="'image-preview'" [src]="attachment.url"></rs-web-picture>
  }
} @else {
  <rs-web-loader></rs-web-loader>
}
